import { makeStyles } from '@material-ui/core/styles';
import { theme } from 'shared/date-pickers/BaseDatePicker/theme';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(10),
    padding: theme.spacing(26, '7%'),
    flex: 3,
  },
  name: {
    paddingTop: ({ topUpSuccess }: LayoutDirection & { topUpSuccess?: boolean }) =>
      topUpSuccess === true ? '25%' : '64%',
    paddingBottom: theme.spacing(12.5),
    fontSize: theme.spacing(12),
    lineHeight: theme.spacing(16.5) + 'px',
    color: '#233B58',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(250),
  },
  leftBlockWrapper: {
    flex: 1,
    // marginRight: theme.spacing(65),
    margin: ({ direction }: LayoutDirection & { topUpSuccess?: boolean }) =>
      direction === 'rtl' ? theme.spacing(0, 0, 0, 65) : theme.spacing(0, 65, 0, 0),
    maxWidth: theme.spacing(250),
  },
  stepTitle: {
    fontSize: theme.spacing(12),
    lineHeight: theme.spacing(16.5) + 'px',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(250),
    color: '#233B58',
  },
  formWrapper: {
    padding: theme.spacing(41, 0, 67),
    width: '100%',
    maxWidth: theme.spacing(440),

    '& button[type="submit"]': {
      flex: 1,
    },

    '& form': {
      width: 'unset',
    },
  },
  title: {
    fontSize: theme.spacing(20),
    lineHeight: theme.spacing(24) + 'px',
    color: '#233B58',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(300),
    paddingBottom: theme.spacing(16),
  },
  subtitle: {
    fontSize: theme.spacing(10),
    lineHeight: theme.spacing(13) + 'px',
    color: '#707070',
    paddingBottom: theme.spacing(25),
  },
  skipBtn: {
    maxWidth: theme.spacing(45),
  },
  skipAndNextBtn: {
    maxWidth: theme.spacing(85),
  },
  topUpWrapper: {
    minHeight: theme.spacing(108),
    background: theme.palette.primary.main,
    borderRadius: theme.spacing(7.5),
    marginTop: theme.spacing(15),
    padding: theme.spacing(0, 25),
  },
  topUpTitle: {
    textAlign: 'center',
    paddingTop: theme.spacing(40),
  },
  topUpText: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.spacing(9),
    lineHeight: theme.spacing(13.5) + 'px',
    fontFamily: 'Poppins',
    fontWeight: theme.spacing(250),
  },
  topUpName: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.spacing(11.5),
    lineHeight: theme.spacing(17) + 'px',
    fontFamily: 'Poppins',
    fontWeight: theme.spacing(350),
    padding: theme.spacing(8, 0),
  },
  topUpWindow: {
    background: '#FFFFFF1A 0% 0% no-repeat padding-box',
    width: theme.spacing(54.5),
    height: theme.spacing(67.5),
    position: 'relative',
    bottom: theme.spacing(7.5),

    '&::before': {
      content: "''",
      display: 'block',
      position: 'relative',
      background: '#FFFFFF1A 0% 0% no-repeat padding-box',
      width: theme.spacing(54.5),
      height: theme.spacing(67.5),
      top: theme.spacing(12),
      left: theme.spacing(25),
    },
  },
  topUpButton: {
    background: theme.palette.background.paper,
    textAlign: 'center',
    '&:hover, &:focus': {
      background: theme.palette.background.paper,
    },
    '& > span span': {
      font: 'normal normal bold 22px/33px Poppins',
    },
  },
  dividerBlock: {
    width: '100%',
    textAlign: 'center',
    padding: theme.spacing(33, 0, 28),
  },
  divider: {
    fontSize: theme.spacing(11),
    color: '#233B58',
    fontWeight: theme.spacing(250),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '&::after, &::before': {
      content: "''",
      display: 'inline-block',
      height: theme.spacing(0.5),
      width: '47%',
      background: theme.palette.primary.main,
    },
  },
  chooseHowTopUpBalanceBlock: {
    width: '100%',
    maxWidth: theme.spacing(440),
  },
  bankTransferBlock: {
    borderRadius: theme.spacing(7.5),
    background: '#F5F5F5 0% 0% no-repeat padding-box',
    padding: theme.spacing(33.5, 23),
    height: theme.spacing(108),
  },
  email: {
    fontSize: theme.spacing(12.5),
    lineHeight: theme.spacing(19) + 'px',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(350),
  },
  bankTransferBlockText: {
    fontSize: theme.spacing(10),
    lineHeight: theme.spacing(19) + 'px',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(250),
    paddingBottom: theme.spacing(8),

    '&:last-child': {
      paddingBottom: 0,
    },
  },
  topUpBalanceForm: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: '#F7F7F7 0% 0% no-repeat padding-box',
    borderRadius: theme.spacing(14),
    width: theme.spacing(445),
    maxHeight: theme.spacing(495),
    padding: theme.spacing(32, 28),
  },
  topUpBalanceTitle: {
    fontSize: theme.spacing(15),
    lineHeight: theme.spacing(19) + 'px',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: theme.spacing(450),
  },
}));
